import React, { useState } from 'react';
import Sidebar from './Sidebar';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState<boolean>(false);

  const handleSidebarToggle = (expanded: boolean) => {
    setIsSidebarExpanded(expanded);
  };

  return (
    <div style={{ backgroundColor: "#f0f0f0", minHeight: "100vh" }}>
      <div className="dashboard-container">
        {/* Left Sidebar */}
        <Sidebar 
          onToggle={handleSidebarToggle}
        />
        
        {/* Main Content */}
        <div 
          className="main-content"
          style={{
            marginLeft: isSidebarExpanded ? '2px' :'2px',
            transition: 'margin-left 0.3s ease',
            width: `calc(100% - ${isSidebarExpanded ? '250px' : '70px'})`
          }}
        >
          {/* Header */}
          
          {/* <div style={{ paddingLeft:"12px"}}><Header collegeDetails={collegeDetails} /></div> */}
          
          {/* Dynamic Content Area */}
          <div className="dashboard-content">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
